import React, { useState, useEffect  } from "react";
import { Navigate, useNavigate } from "react-router";
import {  Link, NavLink } from "react-router";

import AuthService from "../services/auth.service";

import { useAuth } from "../context/AuthContext";

import Template from "./common/template/Template";
import LogoutIcon from "./common/template/icons/LogoutIcon"


const Profile = () => {

   const {user} = useAuth();

     const navigate = useNavigate();


  const linkClass = `m-1  focus:text-white text-red-500 hover:text-red-500 text-center `;

  
  const wrapperClass = `w-full h-full p-4 mb-4 mt-12 mx-auto border border-slate-600  rounded-lg md:rounded-b-none  shadow-md bg-white`;

  //const currentUser = AuthService.getCurrentUser();
  const[currentUser,setCurrentUser] = useState(null);

  function maskString(str,length) {
    // Use a regular expression that matches any character (the '.' dot)
    // with the 'g' flag for global replacement.

   // const maskedFirst = "*".repeat(str.length - length) + str.slice(-length);
    const maskedLast = str.slice(0,length)+"*".repeat(str.length - length);
    //return str.replace(/./g, '*');
    //return maskedFirst
    return maskedLast;
  } 

  useEffect(()=>{

    

    if(user){

      setCurrentUser(user);


    }  else {
       
      navigate('/login')
    }

   
  

    

  },[]);

  return (
    <Template>
      <div className={wrapperClass}>
        
          <h4 className="text-zinc-600">
            Profile
            <img
            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
            alt="profile-img"
            className="w-20 sm:w-32 rounded-full opacity-75 z-10 float-right"
            /> 
          </h4>
          
           
        {
           currentUser ? ( 
           <div className="flex flex-col justify-start items-start">
              
              <h2 className=" text-lg text-sky-400">{currentUser.fullname}</h2> 
              
              <p>
                <strong className="text-secondary">Id:</strong> {currentUser.uId}
              </p>
              <p>
                <strong className="text-secondary">Email:</strong> {maskString(currentUser.email,10)}
              </p>
              <p className="text-xs text-secondary">
                Valoramos mucho tu privacidad, por eso intentamos manter la cantidad de datos personales que recolectamos al minimo.
              </p>
           
              <Link to={"/logout"} className={`group rounded-full w-8 h-8 bg-red-500 hover:bg-red-500 hover:shadow-lg hover:scale-105 transition `+linkClass}>
                      <LogoutIcon className="w-7 h-7 stroke-white"/>
                              <span className="">Logout</span>
              </Link>
           
           </div>
        
           ) : ('Sorry you need to login again')
      
        }
        
        {/*
        <strong>Authorities:</strong>
        <ul>
          {currentUser.roles &&
            currentUser.roles.map((role, index) => <li key={index}>{role}</li>)}
        </ul>
          */}
      </div>
    </Template>
  );
};

export default Profile;
